import { Dropdown, Input } from "components/common";
import { useState } from "react";
// import { getErrorMessage } from "utils";
import './index.scss';


export const EthereumForm = ({wallets, walletByOrg, setPayload, payload, handleSearchWalletByOrg, handleSearchOwner, setWalletByOrgBackUp, handleSearchHolder, setWallets, walletsByOrgBackUp, walletsBackUp, errors, register}) => {
    const [ownerAccount, setOwnerAccount] = useState();
    const [holderAccount, setHolderAccount] = useState();
    const [pwdToggle, setPwdToggle] = useState(false);

    const setAccountInvokingParty = (option) => {
        setPayload({...payload, partyAccount: option})
    }

    const handlChangePassword = (e) => {
        setPayload({...payload, password: e.target.value})
    }

    const hanldOnClickIcon = (e) => {
        setPwdToggle(!pwdToggle);
    }

    return (
        <div className="tr__ethereunForm">
        <div className="row">
                <div className="col-12">
                    <Dropdown
                        className="select"
                        icon="icon-chevron-down"
                        iconPosition="right"
                        mode="input"
                        name="invokingPartyAccount"
                        label={"Invoking party account *"}
                        options={walletByOrg.filter(x => x.address !== payload?.ownerAccount?.address && x.address !== payload?.holderAccount?.address)?.map(type => {
                            return {
                                _id: type._id,
                                address: type.address,
                                value: type.value + ` (${type.address})`,
                                orgId: type.orgId
                            }
                        })}
                        defaultValue={payload.partyAccount ? payload.partyAccount : ''}
                        onChange={option => {
                            setAccountInvokingParty(option);
                            setWalletByOrgBackUp(walletsByOrgBackUp);
                        }}
                        onInputChange={handleSearchWalletByOrg}
                        // refs={register({ required: true })}
                        // error={!!errors.invokingPartyAccount}
                        // errorMessage={getErrorMessage(errors.invokingPartyAccount, "Invoking party account")}
                        placeholder="Invoking party account"
                        dropdownPosition="center"
                    />
                </div>
                <div className="col-12">
                    <Input
                        label="Invoking party account address *"
                        defaultValue={payload.partyAccount ? payload.partyAccount.address : ""}
                        disabled={true}
                        name="invokingPartyAddress"
                        // refs={register({ required: true })}
                        // error={!!errors.invokingPartyAddress}
                        // errorMessage={getErrorMessage(errors.invokingPartyAddress, "Invoking party account address")}
                    />
                </div>
                <div className="col-12">
                    <Input
                        label="Invoking party wallets password *"
                        type={!pwdToggle ? 'password' : 'text'}
                        onChange={handlChangePassword}
                        name="invokingPartyPassword"
                        // refs={register({ required: true })}
                        // error={!!errors.invokingPartyPassword}
                        // errorMessage={getErrorMessage(errors.invokingPartyPassword, "Invoking party wallets password")}
                        icon={pwdToggle ? "icon-eye-slash" : "icon-eye"}
                        iconPosition="right"
                        onIconClick={hanldOnClickIcon}
                        defaultValue=""
                    />
                </div>
                <div className="col-12">
                    <Dropdown
                        icon="icon-chevron-down"
                        iconPosition="right"
                        label="Owner account*"
                        defaultValue=""
                        mode="input"
                        dropdownPosition="center"
                        options={wallets?.filter(x => x.address !== payload?.partyAccount?.address).map(type => {
                            return {
                                _id: type._id,
                                address: type.address,
                                value: type.value + ` (${type.address})`,
                                orgId: type.orgId
                            }
                        })}
                        onChange={option => {
                            setOwnerAccount(option);
                            setPayload({...payload, ownerAccount: option});
                            setWallets(walletsBackUp);
                        }}
                        onInputChange={handleSearchOwner}
                        name="ownerAccount"
                        // refs={register({ required: true })}
                        // error={!!errors.ownerAccount}
                        // errorMessage={getErrorMessage(errors.ownerAccount, "Owner account")}
                        placeholder="Owner account"
                    />
                </div>
                <div className="col-12">
                    <Input
                        label="Owner account address *"
                        defaultValue={ownerAccount ? ownerAccount.address : ""}
                        disabled={true}
                        // refs={register({ required: true })}
                        // error={!!errors.ownerAccountAddress}
                        // errorMessage={getErrorMessage(errors.ownerAccountAddress, "Owner account address")}
                        name="ownerAccountAddress"
                    />
                </div>
                <div className="col-12">
                    <Dropdown
                        icon="icon-chevron-down"
                        iconPosition="right"
                        label="Holder account*"
                        defaultValue=""
                        mode="input"
                        dropdownPosition="center"
                        options={wallets?.filter(x => x.address !== payload?.partyAccount?.address).map(type => {
                            return {
                                _id: type._id,
                                address: type.address,
                                value: type.value + ` (${type.address})`
                            }
                        })}
                        onChange={option => {
                            setHolderAccount(option);
                            setPayload({...payload, holderAccount: option});
                            setWallets(walletsBackUp);
                        }}
                        // refs={register({ required: true })}
                        // error={!!errors.holderAccount}
                        // errorMessage={getErrorMessage(errors.holderAccount, "Holder account")}
                        name="holderAccount"
                        onInputChange={handleSearchHolder}
                        placeholder="Holder account"
                        account="holder_account"
                    />
                </div>
                <div className="col-12">
                    <Input
                        label="Holder account address *"
                        defaultValue={holderAccount ? holderAccount.address : ""}
                        disabled={true}
                        name="holderAccountAddress"
                        // refs={register({ required: true })}
                        // error={!!errors.holderAccountAddress}
                        // errorMessage={getErrorMessage(errors.holderAccountAddress, "Holder account address")}
                    />
                </div>
            </div>
        </div>
    )
}
